import { GoodsNutrientRegistModel } from './vo/goods-nutrient-regist.model';
import { GoodsNutrientModel } from './vo/goods-nutrient.model';
import { KYMW1107Component } from './kymw1107.component';

/**
 * 商品栄養成分情報メンテナンス画面の値を管理するクラス
 *
 * @export KYMW1107Model
 * @class KYMW1107Model
 */
export class KYMW1107Model {

  kymw1107Component: KYMW1107Component;

  // 編集有無フラグ
  public isEdited: boolean = <boolean>false;

  /**
   * Ｐコード
   */
  public pCode: string = <string>'';

  /**
   * アイテムコード
   */
  public itemCode: string = <string>'';

  /**
   * 商品案内用商品名
   */
  public guideGoodsName: string = <string>'';

  /**
   * 商品案内用規格名
   */
  public guideStandardName: string = <string>'';

  /**
   * 分析連番
   */
  public analysisSeqNo: string = <string>'';

  /**
   * 分析単位
   */
  public analysisUnit: string = <string>'';

  /**
   * 栄養成分備考
   */
  public nutritionalNote: string = <string>'';

  /**
   * 栄養成分リスト
   */
  public nutrientComponentList: Array<any> = null;

  /**
		 * サーバからの受信データにて商品栄養成分情報を更新する
		 *
		 * @param serverData サーバからの受信データ
		 */
  public setResultData(serverData: any): void {

    // 検索結果を保持
    this.analysisSeqNo = serverData.AnalysisSeqNo;									// 分析連番
    this.analysisUnit = serverData.AnalysisUnit;									// 分析単位
    this.nutritionalNote = serverData.NutritionalNote;								// 栄養成分備考
    this.nutrientComponentList = serverData.NutritionalList;

    // 栄養成分リストの栄養成分量をnullにしておくと、半角スペースが表示されてしまうので
    for (let i = Number(0); i < this.nutrientComponentList.length; i++) {
      if (this.nutrientComponentList[i].NutritionalQuantity == null) {
        this.nutrientComponentList[i].NutritionalQuantity = '';
      }
    }
    // 編集有無フラグ初期化
    this.isEdited = false;

    // 一覧の有効化
    this.kymw1107Component.dg_NutrientComponentList.isDisabled = false;

    // 初期フォーカス設定
    this.kymw1107Component.txta_AnalysisUnit.textarea.nativeElement.focus();
  }

  /**
   * 栄養成分情報登録用VO取得
   */
  public getGoodsNutrientRegistVO(): GoodsNutrientRegistModel {

    // 栄養成分情報登録用VO初期化処理
    const vo: GoodsNutrientRegistModel = new GoodsNutrientRegistModel();
    vo.pCode = this.pCode;
    vo.itemCode = this.itemCode;
    vo.analysisSeqNo = this.analysisSeqNo;
    vo.analysisUnit = this.analysisUnit.replace(/(\n|\r|\0|\x0B)/gm, '');
    vo.nutrientNote = this.nutritionalNote.replace(/(\n|\r|\0|\x0B)/gm, '');

    const tempNutrientList: Array<any> = new Array<any>();
    let tempVO: GoodsNutrientModel;

    for (let i = Number(0); i < this.nutrientComponentList.length; i++) {   // 商品栄養成分リスト要素数分ループする

      // ArrayCollectionに追加するVOの生成
      tempVO = new GoodsNutrientModel();
      tempVO.pCode = this.pCode;                                                    // Ｐコード
      tempVO.itemCode = this.itemCode;                                              // アイテムコード
      tempVO.analysisSeqNo = this.analysisSeqNo;                                    // 分析連番
      tempVO.nutritionalCode = this.nutrientComponentList[i].NutritionalCode;    // 栄養成分コード
      tempVO.nutritionalName = this.nutrientComponentList[i].NutritionalName;    // 栄養成分名
      tempVO.nutritionalQuantity = this.nutrientComponentList[i].NutritionalQuantity;   // 栄養成分値
      tempVO.nutrientUnit = this.nutrientComponentList[i].NutritionalUnit;       // 栄養成分単位
      tempVO.publishDiv = this.nutrientComponentList[i].PublishDiv;              // 表示区分（0：誌面表示なし、1：あり）
      tempVO.hierarchy = this.nutrientComponentList[i].Hierarchy;                // 階層
      tempNutrientList.push(tempVO);
    }

    vo.nutrientComponentList = tempNutrientList;

    // 栄養成分情報登録用VOを返却
    return vo;
  }
}
